/* eslint-disable */
import React from 'react'
import PropTypes from 'prop-types'

// components
import {
  Grid,
  FormControl,
  Select,
  MenuItem,
  FormHelperText,
  IconButton,
} from '@mui/material'
import CloseRounded from '@mui/icons-material/CloseRounded'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import InputLabel from '../inputLabel'

// icons

// utils
import { noop } from '../../utils/general'
import { t } from 'i18next'

function SelectField({
  label,
  error,
  onChange,
  value,
  id,
  styles,
  options,
  inputStyle,
  inputLabelStyle,
  placeholder,
}) {
  return (
    <Grid item>
      <FormControl sx={styles}>
        <InputLabel label={label} styles={inputLabelStyle} />
        <Select
          id={id}
          key={value}
          value={value}
          sx={inputStyle}
          onChange={onChange}
          endAdornment={
            value && (
              <IconButton
                size="small"
                onClick={() => onChange(null)}
                onMouseDown={(event) => {
                  event.stopPropagation()
                }}
                style={{ margin: '0px', width: 'auto', marginRight: '12px' }}
              >
                <CloseRounded />
              </IconButton>
            )
          }
          displayEmpty
          renderValue={(value) => {
            if (!value) return t(placeholder)
            const selectedOption = options.find(
              (option) => option.value === value,
            )
            return selectedOption ? selectedOption.label : ''
          }}
          IconComponent={KeyboardArrowDownIcon}
        >
          {options.map((option) => (
            <MenuItem key={option?.value} value={option?.value}>
              {option?.label}
            </MenuItem>
          ))}
        </Select>
        <FormHelperText>{error}</FormHelperText>
      </FormControl>
    </Grid>
  )
}

SelectField.propTypes = {
  error: PropTypes.string,
  onChange: PropTypes.func,
  styles: PropTypes.object,
  options: PropTypes.array,
  value: PropTypes.string,
  inputStyle: PropTypes.object,
  placeholder: PropTypes.string,
  inputLabelStyle: PropTypes.object,
}

SelectField.defaultProps = {
  error: undefined,
  onChange: noop,
  styles: { width: '400px', marginTop: '20px' },
  inputStyle: { margin: '0px', width: 'auto' },
  options: [],
  value: undefined,
  placeholder: 'select-view-user',
  inputLabelStyle: {},
}

export default SelectField
